import React, { HTMLAttributes, useMemo } from 'react';
import { AddIcon } from '../../../../assets/icons/AddIcon';
import { DecreaseIcon } from '../../../../assets/icons/DecreaseIcon';
import { TooltipPosition } from '../../../../libraries/Tooltips';
import { getMergedClassNames } from '../../../../utils/HTMLutils';
import Checkbox, { CheckboxProps } from '../../../checkbox/Checkbox';
import IconButton from '../../../iconButton/IconButton';
import './LeftControlWithLabel.scss';
const rootClassName = 'component-table-left-checkbox-with-label';

export interface LeftControlWithLabelElement extends CheckboxProps {
  label?: React.ReactNode | JSX.Element;
  justifyContent?: never;
  spanProps?: never;
  anchorLabelToCheckbox?: never;
  removeUserSelect?: never;
  type?: 'checkbox' | 'addRemove';
  w100?: boolean;
}

export interface SpanPropsExtended extends HTMLAttributes<HTMLSpanElement> {
  'tooltip-position'?: TooltipPosition;
  'tooltip-text'?: string;
}

export interface LeftControlWithLabelString extends CheckboxProps {
  label?: string;
  justifyContent?: string;
  spanProps?: SpanPropsExtended;
  anchorLabelToCheckbox?: boolean;
  removeUserSelect?: boolean;
  type?: 'checkbox' | 'addRemove';
  w100?: boolean;
}

export const LeftControlWithLabel = (
  props: LeftControlWithLabelElement | LeftControlWithLabelString
) => {
  const style = useMemo(() => {
    const style = {
      justifyContent: props.justifyContent,
      ...(props.spanProps?.style ?? {}),
    };
    if (props.removeUserSelect) {
      style.userSelect = 'none';
    }
    if (props.anchorLabelToCheckbox && !props.disabled) {
      style.cursor = 'pointer';
    }
    return style;
  }, [
    props.anchorLabelToCheckbox,
    props.disabled,
    props.justifyContent,
    props.removeUserSelect,
    props.spanProps,
  ]);

  return (
    <div
      className={getMergedClassNames([
        rootClassName,
        props.w100 ? 'w-100' : '',
      ])}
    >
      <span
        className={`${rootClassName}-checkbox-wrapper`}
        tooltip-position={props['tooltip-position']}
        tooltip-text={props['tooltip-text']}
      >
        {props.type === 'addRemove' ? (
          <IconButton
            className={getMergedClassNames([
              `${rootClassName}-add-remove-button`,
              props.value ? `${rootClassName}-danger` : '',
            ])}
            icon={props.value ? <DecreaseIcon /> : <AddIcon />}
            disabled={props.disabled}
            onClick={(evt) => {
              evt.stopPropagation();
              props.onChange?.(!props.value, evt);
            }}
          />
        ) : (
          <Checkbox
            value={props.value}
            disabled={props.disabled}
            onChange={props.onChange}
            theme={props.theme}
          />
        )}
      </span>
      <span
        {...(props.spanProps ?? {})}
        className={getMergedClassNames([
          `${rootClassName}-label-wrapper`,
          props.spanProps?.className || '',
        ])}
        style={style}
        onClick={(evt) => {
          if (props.anchorLabelToCheckbox) {
            props.onChange?.(!props.value, evt);
          }
          props.spanProps?.onClick?.(evt);
        }}
      >
        {props.label}
      </span>
    </div>
  );
};
